export const FETCH_ROLE_DETAIL_REQUESTED = 'FETCH_ROLE_DETAIL_REQUESTED';
export const FETCH_ROLE_DETAIL_SUCCEEDED = 'FETCH_ROLE_DETAIL_SUCCEEDED';
export const FETCH_ALL_PERMISSIONS_GROUP_REQUESTED = 'FETCH_ALL_PERMISSIONS_GROUP_REQUESTED';
export const FETCH_ALL_PERMISSIONS_GROUP_SUCCEEDED = 'FETCH_ALL_PERMISSIONS_GROUP_SUCCEEDED';
export const SELECT_ALL_PERMISSIONS_GROUP = 'SELECT_ALL_PERMISSIONS_GROUP';
export const SET_PERMISSIONS_ROLE_REQUESTED = 'SET_PERMISSIONS_ROLE_REQUESTED';
export const SET_PERMISSIONS_ROLE_SUCCEEDED = 'SET_PERMISSIONS_ROLE_SUCCEEDED';
export const DETACH_PERMISSION_ROLE_REQUESTED = 'DETACH_PERMISSION_ROLE_REQUESTED';

